import { Component, Input } from '@angular/core'
import {
	FormValidationComponent,
	ValidationMessages,
} from '@ui/Components/Form/FormValidation.Component'
import HttpError, { FormErrors } from '@ui/HttpError'
import Guest from '@client/Guest'
import { debounceTime } from 'rxjs/operators'
import { createGuest } from '@client/utils'
import { ReactiveFormsModule, Validators } from '@angular/forms'
import { TextInputComponent } from '@ui/Components/Form/TextInput/TextInput.Component'
import { TextAreaComponent } from '@ui/Components/Form/TextArea/TextArea.Component'

import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'

@Component({
	selector: 'guest-form-component',
	templateUrl: './GuestForm.Component.html',
	imports: [
		ReactiveFormsModule,
		TextInputComponent,
		TextAreaComponent,
		RaisedButtonComponent,
	],
})
export class GuestFormComponent extends FormValidationComponent {
	@Input() protected readonly requiresSubmit: boolean = false

	@Input() protected readonly guest: Guest

	@Input() private readonly submissionHandler: (guest: Guest) => Promise<void>

	public formErrors: FormErrors = {
		name: '',
		dietary_requirements: '',
	}

	protected validationMessages: ValidationMessages = {
		name: {
			required: 'Name is required',
		},
		dietary_requirements: {},
	}

	constructor() {
		super()
	}

	protected buildForm(): void {
		this.form = this.formBuilder.group({
			name: [this.guest.name, [Validators.required]],
			dietary_requirements: [this.guest.dietary_requirements, []],
		})

		if (!this.requiresSubmit) {
			this.form.valueChanges.pipe(debounceTime(500)).subscribe(async () => {
				await this.handleSubmit()
			})
		}
	}

	protected readonly handleSubmit = async (): Promise<void> => {
		this.validateForm()

		if (!this.form.valid) {
			return
		}

		const guest = createGuest()

		guest.id = this.guest.id

		guest.user_id = this.guest.user_id

		guest.name = this.form.controls.name.value

		guest.status = this.guest.status

		guest.dietary_requirements = this.form.controls.dietary_requirements.value

		try {
			await this.submissionHandler(guest)
		} catch (error) {
			if (error instanceof HttpError) {
				if (error.isUnprocessableEntity()) {
					this.formErrors = error.handleFormErrors(this.formErrors, 'guest')

					this.markInvalidFields()
				}
			} else {
				throw error
			}
		}
	}
}
